import { Droplets, Wind, AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  { icon: Droplets, title: "Water Damage Cleanup", description: "Fast extraction, structural drying, and complete restoration.", link: "/water-damage" },
  { icon: Wind, title: "Mold & Moisture Problems", description: "Thermal imaging assessment, containment, and professional remediation.", link: "/mold-remediation" },
  { icon: AlertTriangle, title: "Sewage & Category 3", description: "Safe removal, disinfection, and restoration with proper PPE.", link: "/sewage-cleanup" },
];

export const ServicesSection = () => {
  return (
    <section className="py-8 bg-background">
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="text-xl font-bold text-wtr-gray mb-4 text-center">Our Core Services</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {services.map((s, i) => (
            <Link key={i} to={s.link} className="flex items-start gap-3 bg-card rounded-lg p-3 border border-border hover:shadow-soft transition-shadow">
              <div className="w-8 h-8 bg-gradient-to-br from-wtr-blue to-wtr-blue-light rounded-md flex items-center justify-center shrink-0">
                <s.icon className="w-4 h-4 text-white" />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-wtr-gray leading-tight">{s.title}</h3>
                <p className="text-xs text-wtr-gray-light mt-0.5">{s.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};